<mat-sidenav-container class="container">
  <mat-sidenav #drawer class="sidebar" mode="side" opened>
    <nav>
      <a routerLink="/inicio" routerLinkActive="active">
        <mat-icon>home</mat-icon>
        <span>Inicio</span>
      </a>

      <a routerLink="/pacientes" routerLinkActive="active">
        <mat-icon>groups</mat-icon>
        <span>Pacientes</span>
      </a>

      @if (tieneRol('MEDIC@') || tieneRol('ADMIN')) {
        <a routerLink="/consultas" routerLinkActive="active">
          <mat-icon>assignment</mat-icon>
          <span>Consultas</span>
        </a>
      }

      @if (tieneRol('MEDIC@') || tieneRol('ADMIN')) {
        <a routerLink="/estudios" routerLinkActive="active">
          <mat-icon>folder_shared</mat-icon>
          <span>Expedientes</span>
        </a>
      }

      <a routerLink="/configuraciones" routerLinkActive="active">
        <mat-icon>settings</mat-icon>
        <span>Configuraciones</span>
      </a>
    </nav>

    @if (user) {
      <div class="perfil">
        <div class="avatar">
          {{ getIniciales() }}
        </div>

        <div>
          <h4>{{ user.clinica?.nombre }}</h4>

          @if (tieneRol('ADMIN')) {
            <span>
              Administrador <br />
              {{ user.nombre }} {{ user.apellidoPaterno }} {{ user.apellidoMaterno }}
            </span>
          }
          @if (tieneRol('MEDIC@')) {
            <span>
              Medic@ <br />
              {{ user.nombre }} {{ user.apellidoPaterno }} {{ user.apellidoMaterno }}
            </span>
          }
          @if (tieneRol('ENFERMER@')) {
            <span>
              Enfermer@ <br />
              {{ user.nombre }} {{ user.apellidoPaterno }} {{ user.apellidoMaterno }}
            </span>
          }
        </div>
      </div>
    }
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <span class="logo"> Expediente Avicena </span>

      <span class="spacer"></span>

      @if (user) {
        <span class="email">
          {{ user.email }}
        </span>
      }

      <button mat-icon-button (click)="cerrarSesion()">
        <mat-icon>logout</mat-icon>
      </button>
    </mat-toolbar>

    <main class="content">
      @if (usuarioListo) {
        <router-outlet></router-outlet>
      } @else {
        <div class="cargando-usuario">Cargando usuario...</div>
      }
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
